<template>
  <v-container>
    <v-layout justify-center>
      <v-flex>
        <v-card>
          <v-app-bar dark color="primary">{{ $t('userRating.ratingsTitle') }}</v-app-bar>
          <v-card-text class="text-center">
            <h3 class="subtitle-1 mb-2">{{ $t('userRating.ratingsText', {points: ratingPoints}) }}</h3>

            <v-rating x-large background-color="primary" v-model="score" dense :readonly="rating_submitted"></v-rating>

            <v-textarea name="comment-text" :label="$t('userRating.comment')" v-model="comment" :readonly="rating_submitted"></v-textarea>
            <span class="text-center" v-if="rating_message">
              <p>{{rating_message}}</p>
            </span>
            <v-btn v-on:click="submitRating" color="primary" :loading="loading" :disabled="rating_submitted">{{ $t('userRating.submit') }}</v-btn>
            <v-col v-if="showRatingHint && !rating_submitted">{{ $t('userRating.ratingsHint') }}</v-col>
          </v-card-text>
          <v-card-actions v-if="!rating_submitted">
            <v-spacer></v-spacer>
            <v-btn text color="primary" to="/" >{{ $t('userRating.later') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="successDialog" persistent max-width="290">
      <v-card :class="[{'countdown': successDialog}, 'success-dialog']">
        <v-card-title class="headline">{{ $t('userRating.successDialogHeadline') }}</v-card-title>
        <v-card-text v-html="$t('userRating.successDialogText')"></v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex'
  import _ from 'lodash';
  import {convertResponseToError} from '../utils/error_messages'
  import {BASE_API_URL} from '../store'

  export default {
    name: 'direct-login',
    data() {
      return {
        score: null,
        loading: false,
        comment: null,
        rating_message: null,
        rating_submitted: false,
        showRatingHint: false,
        successDialog: false
      };
    },
    computed: {
      ...mapGetters(['client_id']),
      ratingPoints() {
        return _.get(this.$store.getters.extensionSettings, 'user-ratings.rating_points');
      }
    },
    methods: {
      async submitRating() {
        if (!this.score) {
          this.showRatingHint = true;
        } else {
          try {
            this.loading = true;

            await this.axios.post(
              `${BASE_API_URL}/api/v1/customer-relationships/${this.client_id}/ratings/`, {
                "score": this.score,
                "comment": this.comment
              });
            this.rating_submitted = true;

            this.successDialog = true;
            setTimeout(() => {
              this.$router.push({name: 'home'});
            }, 3000);
          } catch (error) {
            let error_msg = this.$t("userRating.submit-rating-fail");
            let code_msg = convertResponseToError(error.response, {
              "RATING_ALREADY_SUBMITTED": this.$t("userRating.rating-already-submitted")
            });
            console.error(code_msg, error);
            this.rating_message = `${error_msg}`;
          } finally {
            this.loading = false;
          }
        }
      }
    },
    mounted() {
      this.score = this.$route.query['score'];
      if (this.score) {
        this.rating_message = this.$t("rating-text", {
          score: this.score
        })
        this.submitRating()
      }
    }
  };

</script>


<style lang="scss" scoped>
  .success-dialog {
    &::v-deep .v-card__text {
      padding-bottom: 40px;
      &:before,
      &:after {
        content: '';
        position: absolute;
      }
      &:before {
        width: calc(100% - 48px);
        height: 5px;
        left: 24px;
        bottom: 20px;
        background: rgba(0, 0, 0, 0.1);
      }
      &:after {
        width: calc(100% - 50px);
        left: 25px;
        height: 3px;
        bottom: 21px;
        background: var(--v-primary-base);
        transform: scaleX(0);
        transform-origin: center left;
        animation: countdown 2.8s ease-in-out forwards;
      }
    }
  }

  @keyframes countdown {
    0% {
      transform: scaleX(0);
    }
    100% {
      transform: scaleX(1);
    }
  }
</style>
